import apiClient from "./axios"

export const getAccountBillStatusList = async (params = {}) => {
  const { data } = await apiClient.get("/account-bill-statuses", { params })
  return data
}

export const getAccountBillStatusById = async id => {
  const { data } = await apiClient.get(`/account-bill-statuses/${id}`)
  return data
}

export const createAccountBillStatus = async payload => {
  const { data } = await apiClient.post("/account-bill-statuses", payload)
  return data
}

export const updateAccountBillStatus = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-bill-statuses/${id}`, payload)
  return data
}

export const deleteAccountBillStatus = async id => {
  const { data } = await apiClient.delete(`/account-bill-statuses/${id}`)
  return data
}
